import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { formatDateTime, formatName } from "@tellescope/utils";

export interface FormsSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const FormsSection = ({ enduser }: FormsSectionProps) => {
  const [selectedForm, setSelectedForm] = useState<{ formId: string; formTitle: string }>();
  const [selectedFormResponse, setSelectedFormResponse] = useState<TellescopeModelFromName<"form_responses">>();
  const { t } = useTranslation("contacts");

  const enduserName = formatName(enduser);

  const { breadcrumbs } = useMemo<Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs">>(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Forms"),
        onClick:
          selectedForm || selectedFormResponse
            ? () => {
                setSelectedForm(undefined);
                setSelectedFormResponse(undefined);
              }
            : undefined,
      },
    ];

    if (selectedForm) {
      breadcrumbs.push({
        title: selectedForm.formTitle,
        onClick: selectedFormResponse ? () => setSelectedFormResponse(undefined) : undefined,
      });
    }

    if (selectedFormResponse) {
      breadcrumbs.push({
        title: selectedFormResponse.submittedAt
          ? formatDateTime(selectedFormResponse.submittedAt, "MM/DD/YYYY at hh:mm:ss a")
          : t("Response"),
      });
    }

    return { breadcrumbs };
  }, [selectedForm, selectedFormResponse, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs enduserId={enduser.id} breadcrumbs={breadcrumbs} />
      {selectedFormResponse ? (
        <ContactDetailsSections.FormResponse
          timestamp={selectedFormResponse.submittedAt || selectedFormResponse.updatedAt}
          response={selectedFormResponse}
          enduserId={enduser.id}
          enduserName={enduserName}
          onBack={() => setSelectedFormResponse(undefined)}
          onGeneratePDFClick={() => {}}
          className="flex-grow overflow-y-auto"
        />
      ) : selectedForm ? (
        <ContactDetailsSections.FormResponses
          contactId={enduser.id}
          formId={selectedForm.formId}
          onResponseSelect={(response) => setSelectedFormResponse(response)}
        />
      ) : (
        <ContactDetailsSections.FormsSection
          contact={enduser}
          onSelectForm={(form) => {
            setSelectedForm({
              formId: form.formId,
              formTitle: form.formTitle,
            });
          }}
        />
      )}
    </div>
  );
};
